import React from 'react';

function Footer({ language }) {
  return (
    <footer className='footer-footer'>
      <p className={['en', 'fr'].includes(language) ? 'english-footer' : ''}>
        &copy; 2026 -{' '}
        {language === 'en'
          ? 'Wisdom of the Righteous and the Awliya'
          : language === 'fr'
            ? 'Guidance dans les sagesses des Saints'
            : 'معالم الهداية في حكم الأولياء الصالحين'}
      </p>
    </footer>
  );
}

export default Footer;
